import type {
  FilterParamsHotels,
  SearchParams,
  SortParams,
} from '@/modules/common/context/QueryParams/models';

import {fetchInventory} from '@/redux/v1/hotels/inventory/actions';
import {fetchHotels} from '@/redux/v1/hotels/list/actions';

type FetchHotelsAndInventory = {
  initial: boolean;
  searchParams: SearchParams;
  filterParams: FilterParamsHotels;
  sortParams: SortParams;
  forceNoLimit?: boolean;
  sponsoredAdPositions?: Array<number>;
};

export const fetchHotelsAndInventory =
  (options: FetchHotelsAndInventory) =>
  // @ts-expect-error ...
  (dispatch) => {
    dispatch(fetchHotels(options));
    dispatch(fetchInventory(options));
  };
